import moment from "moment";
import { defaultMemoize } from "reselect";

export type TimeWindowType = {
  start: moment.Moment | null | undefined;
  end: moment.Moment | null | undefined;
};

export type OptionType = {
  label: string;
  value: TimeWindowType;
  key: "past" | "upcoming" | "overdue";
};

export const assignmentsOverviewFilters = {
  upcoming: {
    label: "Upcoming",
    value: "upcoming"
  },
  overdue: {
    label: "Overdue",
    value: "overdue"
  },
  past: {
    label: "Past",
    value: "past"
  }
};

export const defaultFilterState = assignmentsOverviewFilters.upcoming.value;

export const getTeacherToggleOptions = defaultMemoize(
  (now: moment.Moment): Array<OptionType> => [
    {
      label: assignmentsOverviewFilters.upcoming.label,
      key: assignmentsOverviewFilters.upcoming.value as "upcoming",
      value: {
        start: now,
        end: null
      }
    },
    {
      label: assignmentsOverviewFilters.past.label,
      key: assignmentsOverviewFilters.past.value as "past",
      value: {
        start: null,
        end: now
      }
    }
  ]
);

export const getStudentToggleOptions = defaultMemoize(
  (now: moment.Moment): Array<OptionType> => [
    {
      label: assignmentsOverviewFilters.upcoming.label,
      key: assignmentsOverviewFilters.upcoming.value as "upcoming",
      value: {
        start: now,
        end: null
      }
    },
    {
      label: assignmentsOverviewFilters.overdue.label,
      key: assignmentsOverviewFilters.overdue.value as "overdue",
      value: {
        start: now.clone().subtract(2, "weeks"),
        end: now
      }
    },
    {
      label: assignmentsOverviewFilters.past.label,
      key: assignmentsOverviewFilters.past.value as "past",
      value: {
        start: null,
        end: now
      }
    }
  ]
);

export const defaultToggleOption = (now: moment.Moment) => ({
  label: assignmentsOverviewFilters.upcoming.label,
  key: assignmentsOverviewFilters.upcoming.value,
  value: {
    start: now,
    end: null
  }
});

export const STATUS_CODES = {
  missed: -2,
  late: -1,
  inProgress: 0,
  completed: 1,
  notStarted: 2
};
